import React from 'react';

/**
 * Catches render-time errors in any child component tree.
 * Shows a fallback UI instead of a white screen.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('[ErrorBoundary]', error.message, info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          display: 'flex', flexDirection: 'column', alignItems: 'center',
          justifyContent: 'center', height: '60vh', gap: 12, color: '#64748b',
          fontFamily: 'Inter, sans-serif', textAlign: 'center', padding: 20,
        }}>
          <div style={{ fontSize: '2rem' }}>Something went wrong</div>
          <div style={{ fontSize: '0.85rem', color: '#94a3b8', maxWidth: 400 }}>
            {this.state.error?.message || 'An unexpected error occurred'}
          </div>
          <button
            onClick={() => { this.setState({ hasError: false, error: null }); window.location.reload(); }}
            style={{
              marginTop: 8, padding: '8px 20px', border: '1px solid #cbd5e1',
              borderRadius: 8, background: '#fff', cursor: 'pointer', fontSize: '0.85rem',
            }}
          >
            Reload Page
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
